import { wordsResponse } from '../../types';
import { UserWordsAction, userWordsActionTypes } from '../type';

interface userWordsState {
  loading: boolean;
  diffWords: wordsResponse[];
  diffWordsEmpty: boolean | null;
}

const initialState: userWordsState = {
  diffWords: [],
  loading: false,
  diffWordsEmpty: null,
};

export const userWordsReducer = (state = initialState, action: UserWordsAction) => {
  switch (action.type) {
    case userWordsActionTypes.FETCH_DIFF_WORDS_USER:
      return {
        ...state,
        loading: true,
        diffWordsEmpty: false,
      };
    case userWordsActionTypes.FETCH_DIFF_WORDS_USER_SUCCESS:
      return {
        ...state,
        diffWords: action.payload,
        loading: false,
      };
    case userWordsActionTypes.DIFFICULT_WORDS_EMPTY:
      return {
        ...state,
        diffWordsEmpty: true,
        loading: false,
      };
    case userWordsActionTypes.DIFFICULT_WORDS_REMOVE:
      return {
        ...state,
        diffWords: [],
      };
    default:
      return state;
  }
};
